import React from 'react'
import { ElementProps } from '../base/element'
import {
  ICommonProps,
  IComponent,
  IDataComponent,
  IDefaultStyles,
  IStyles
} from '../schemamanager/types'
import { Item } from '../base/item'

export interface IFieldComponent extends ICommonProps {
  type: 'field'
  inputComponent: IComponent
  label: string
  hint?: string
  styleLabel?: IStyles
  styleErrorLabel?: IStyles
  styleHint?: IStyles
}

export const Field = (props: ElementProps) => {
  const { sm, events } = props
  const comp = props.comp as IFieldComponent

  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'mb-6 mx-6'
      }
    },
    styleLabel: {
      classes: {
        margin: 'mx-2 my-1',
        display: 'block',
        textColor: 'text-gray-700',
        fontSize: 'text-sm',
        fontWeight: 'font-bold'
      },
    },
    styleErrorLabel: {
      classes: {
        margin: 'mx-2 mt-2',
        display: 'block',
        textColor: 'text-red-500',
        fontStyle: 'italic'
      }
    },
    styleHint: {
      classes: {
        margin: 'mx-2 my-1',
        display: 'block',
        textColor: 'text-gray-700',
        fontSize: 'text-xs',
      },
    },
  }
  const m = props.mergeStyles(style)

  const error = sm.getError(comp.inputComponent as IDataComponent)

  const label = comp.label + (comp.inputComponent['required'] ? sm.Settings.requiredSuffix : '')

  return (
    <div {...m.main} {...events()}>
      {label ? <label {...m.styleLabel}>{label}</label> : <label {...m.styleLabel}>&nbsp;</label>}
      <Item sm={sm} comp={comp.inputComponent} />
      {error && <span {...m.styleLabelError}>{error}</span>}
      {comp.hint && <span {...m.styleHint}>{comp.hint}</span>}
    </div>
  )
}
